module.exports = __webpack_public_path__ + "img/2.2a89505d.png";